import { FC, ReactNode } from "react";
import { Flex } from "@chakra-ui/react";
import { FullBleedSection } from "~/components";

interface Props {
  left: ReactNode;
  right: ReactNode;
  stack?: boolean;
}

const columnProps = {
  direction: { base: "column", md: "row" },
};

const hideProps = {
  display: { base: "none", md: "flex" },
};

export const TwoPanelTemplate: FC<Props> = ({ left, right, stack }) => {
  const stackProps = stack ? columnProps : {};
  const leftProps = stack ? {} : hideProps;

  return (
    <FullBleedSection bg="th.cream1" flexGrow={1} justify="flex-start">
      <Flex flexGrow={1} w="full" {...stackProps}>
        <Flex w="full" {...leftProps}>
          {left}
        </Flex>
        <Flex w="full">{right}</Flex>
      </Flex>
    </FullBleedSection>
  );
};
